import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthGate } from "./components/AuthGate";
import { App } from "./App";
import { BookingPage } from "./pages/BookingPage";
import { CreatorApplicationPage } from "./pages/affiliates/CreatorApplicationPage";
import "./globals.css";
import "./lib/theme"; // applies the persisted theme (class + meta) at boot

/**
 * Public pages stay outside the sign-in gate; the CRM remains protected.
 *   /book/:slug and /creators/apply — public, no auth gate
 *   everything else — wrapped in AuthGate (SyncSuite iframe identity)
 */
createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/book/:slug" element={<BookingPage />} />
        <Route path="/creators/apply" element={<CreatorApplicationPage />} />
        <Route path="/*" element={<AuthGate><App /></AuthGate>} />
      </Routes>
    </BrowserRouter>
  </StrictMode>
);
